export enum EHideReason {
    Visible = 0,
    // DONT USE 0
    EffectiveDate = 1,
    ExpirationDate = 2,
    fundingType = 4,
    erisa = 8,
    lineOfBusiness = 16,
    grandFathered = 32,
    ParentVisibility = 64,
    ParentVisibilityCascade = 128,
    Product = 256,
    Cancellation = 512,
}